import getIn from './getIn'

const getMeta = (form, key, defaultVal = '') => {
  if (!form) return defaultVal
  const v = getIn(form, `meta.${key}`)
  return v !== undefined && v !== null ? v : defaultVal
}

export default getMeta
